export declare interface CommercialManagerOptions {
  request?: CommercialRequest,
}

export declare interface CommercialRequest {
  // 接口域名（如https://api.nes.smoba.qq.com）
  host: String | Function,
}

// 物品分类
export enum CommercialGoodsCategory {
  CommercialGoodsCategoryHero = 1, // 英雄
  CommercialGoodsCategorySkin = 2, // 皮肤
  CommercialGoodsCategoryProps = 4, // 道具礼包
}

// 排序方式（升序、降序、无）
export enum CommercialGoodsSortType {
  CommercialGoodsSortTypeNone = 0, // 无
  CommercialGoodsSortTypeAsc = 1, // 升序
  CommercialGoodsSortTypeDesc = 2, // 降序
}

export declare interface CommercialGoodsSort {
  key: string;
  type: CommercialGoodsSortType;
}

export enum GetGoodsListConditionType {
  GetGoodsListConditionTypeSearch = 1, // 搜索过滤，对应数据GetGoodsListConditionSearch
  GetGoodsListConditionTypeMatch = 2, // 类型匹配（类型、分路），对应数据GetGoodsListConditionMatch
  GetGoodsListConditionTypeRange = 3, // 大小限制（价格），对应数据GetGoodsListConditionRange
}

export declare interface GetGoodsListCondition {
  type: GetGoodsListConditionType;
}

// type等于GetGoodsListConditionTypeSearch时
export declare interface GetGoodsListConditionSearch extends GetGoodsListCondition {
  key: []; // 多个值进行匹配，或关系
  value: []; // 多个值进行匹配，或关系
}

// type等于GetGoodsListConditionMatch时
export declare interface GetGoodsListConditionMatch extends GetGoodsListCondition {
  key: string;
  value: []; // 多个值进行匹配，或关系
}

// type等于GetGoodsListConditionRange时
export declare interface GetGoodsListConditionRange extends GetGoodsListCondition {
  key: string;
  needMin: boolean; // 需要判断小于、小于等于时设置为true
  min: number; // 最小值
  minEqual: boolean; // 判断小于等于min，而不是小于min
  needMax: boolean; // 需要判断大于、大于等于时设置为true
  max: number; // 最大值
  maxEqual: boolean; // 判断大于等于max，而不是大于max
}

export declare interface GetGoodsListParam {
  // 过滤条件数组（如分类、搜索、筛选）
  filterConditions?: GetGoodsListCondition[];
  // 排序方式，只支持一个
  sort?: CommercialGoodsSort;
}

export declare interface GoodsItem {
  id: number, // 物品id
  name: string, // 物品名称
  pic: string, // 物品图片
  bigPic: string, // 详情图片
  desc: string, // 物品描述
  price: number, // 售价
  orgPrice: number, // 原价
  type: number, // 类型
  category: number, // 一级分类
  subCategory: number, // 二级分类
  thirdCategory: number, // 三级分类
}
